import { useMemo } from 'react'

import type { Tag } from '@tribeplatform/gql-client/types'

export const useSortedTags = ({
  sortOrderTagIds,
  tags,
}: {
  sortOrderTagIds: string[]
  tags: Tag[]
}) => {
  const sortedTags = useMemo(() => {
    // Sort tags based on their order in the sortOrderTagIds array
    if (!tags || tags.length === 0) {
      return []
    }
    const tagsMap = new Map(tags.map(tag => [tag.id, tag]))
    return sortOrderTagIds.map(id => tagsMap.get(id)).filter(Boolean)
  }, [sortOrderTagIds, tags])

  return { sortedTags }
}
